<template>
	<!-- Component wrapper -->
	<div class="wrapper">
		<v-icon v-if="icon" :style="`color: ${icon_color}`" class="mb-2">
			{{ icon }}
		</v-icon>
		<h3 v-if="title" :style="`color: ${title_color}`">
			{{ title }}
		</h3>
		<p v-if="description" :style="`color: ${description_color}`">
			{{ description }}
		</p>
	</div><!-- End component wrapper -->
</template>

<script>
export default {
  name: 'EstadoNaoIdeal',
  props: {
    icon: {
      type: String,
      default: null
    },
    icon_color: {
      type: String,
      default: '#cfd5da'
    },
    title: {
      type: String,
      default: null
    },
    title_color: {
      type: String,
      default: '#3d4060'
    },
    description: {
      type: String,
      default: null
    },
    description_color: {
      type: String,
      default: 'rgba(0,0,0,0.87)'
    }
  },
  data: () => ({
  })
};
</script>

<style scoped lang='scss'>
@import "@Assets/css/settings.scss";

.wrapper {
  height: 100%;
  padding: 12px;
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;

  .v-icon {
    user-select: none;
    font-size: 48px !important;
  }
}
</style>
